import React, { useMemo, useRef } from 'react';
import classNames from 'classnames';
import { isNil, round } from 'lodash';
import { Box, Grid, Typography } from '@mui/material';

import styles from './EnergyTooltip.module.scss';

interface Props {
  energy?: number;
  graphWidth: number;
  tooltipLeftPosition?: number;
}

const ForecastGraphEnergyTooltip = ({ energy, graphWidth, tooltipLeftPosition }: Props) => {
  const tooltipRef = useRef<HTMLDivElement | null>(null);

  const positionStyles = useMemo(() => {
    const leftPosition = tooltipLeftPosition ?? 0;
    const tooltipWidth = tooltipRef?.current?.offsetWidth ?? 0;
    let leftVal = leftPosition;
    if (leftPosition > 25) leftVal = leftPosition - tooltipWidth / 2;
    if (graphWidth - leftPosition < 25) leftVal = leftPosition - tooltipWidth;
    return {
      left: `${leftVal}px`,
    };
  }, [graphWidth, tooltipLeftPosition]);

  const energyLabel = useMemo(() => {
    if (isNil(energy)) {
      return '--';
    }
    return (energy || 0) < 10 ? round(energy || 0, 1) : round(energy || 0, 0);
  }, [energy]);

  return (
    <Box
      className={styles.container}
      data-testid="energy-graph-tooltip"
      ref={tooltipRef}
      style={positionStyles}
    >
      <Grid data-testid="energy-reading" item>
        <Box className={classNames(styles.content)}>
          <Grid container spacing={1} justifyContent="space-around">
            <Grid item mobile={12}>
              <Typography variant="callout1" component="span">
                {energyLabel}
                <Typography component="span" variant="callout2">
                  kJ
                </Typography>
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Box>
  );
};

export default ForecastGraphEnergyTooltip;
